import React from "react";
import { Dot, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { trackDevice } from "../../../../redux/assets/assetsActions";
import { useDispatch, useSelector } from "react-redux";
import { cn } from "@/lib/utils";
import { useNavigate } from "react-router-dom";

export default function DeviceRow({ device }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const IdDeviceToTrack = useSelector((state) => state.assets.IdDeviceToTrack);
  const { t } = useTranslation();

  const isDeviceMoving = true;

  const handleViewDetails = () => {
    navigate(`/dashboard/fleet/devices/${device._id}`);
  };

  return (
    <div className={cn(
      "w-full bg-white rounded-lg shadow-md mb-4 border border-gray-200 hover:shadow-lg transition-shadow flex flex-col"
    )}>
      <div className="p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="font-bold text-lg text-blue-700 hover:underline cursor-pointer" onClick={handleViewDetails}>{device.deviceId}</span>
            <span className="px-2 py-0.5 text-xs font-semibold rounded-full bg-gray-200 text-gray-700">
              {device.vehicle.plate}
            </span>
          </div>
          <div className="flex items-center text-sm text-gray-600">
            {isDeviceMoving ? (
              <Dot className="w-6 h-6 text-green-500 -ml-1.5" />
            ) : (
              <Dot className="w-6 h-6 text-red-500 -ml-1.5" />
            )}
            <span>{isDeviceMoving ? "Moving" : "Stopped"}</span>
            <span className="mx-2">|</span>
            <span>{device.vehicle.brand} / {device.vehicle.model}</span>
          </div>
        </div>

        <div className="flex items-center gap-2 mt-2 sm:mt-0 flex-shrink-0">
          <Button
            variant="default"
            size="sm"
            onClick={() => dispatch(trackDevice(device._id))}
            disabled={device._id === IdDeviceToTrack}
            className="bg-blue-600 hover:bg-blue-700 text-white disabled:bg-gray-400"
          >
            {t("dashboard.trackButton")}
          </Button>
        </div>
      </div>

      <div className="p-4 border-t border-gray-200 mt-auto">
        <div className="flex justify-end">
          <Button
            variant="outline"
            className="text-blue-600 hover:text-blue-700 border-blue-300 hover:bg-blue-50 text-xs px-2 py-1"
            onClick={handleViewDetails}
          >
            <Eye className="w-3 h-3 mr-1" />
            {t("deviceRow.viewDetails", "View Details")}
          </Button>
        </div>
      </div>
    </div>
  );
} 